import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { doShowModal } from '../store/actions';
import { rem, colors, device } from '../lib/global-styles';
import logoImage from '../images/logo_sky_rec_prog.svg';
import headerImage from '../images/banner-desk.png';
import headerMobileImage from '../images/banner-mobile.png';
import secondaryHeaderImage from '../images/img-header-secondary.png';

const HeaderWrapper = styled.header`
  align-items: center;
  justify-content: center;
  background: no-repeat center 0;
  background-image: ${props =>
    props.secondary ? `url(${secondaryHeaderImage})` : `url(${headerImage})`};
  background-size: cover;
  flex-direction: column;
  margin: auto;
  height: ${props => (props.secondary ? `${rem(254)}` : `${rem(472)}`)};

  div.logo-img {
    max-width: ${rem(1070)};
    margin: auto;

    img {
      visibility: visible;
      content: none;
      width: ${rem(425)};
      height: ${rem(123)};
      margin: ${rem(30)} 0;
    }
  }

  p {
    color: ${colors.white};
    font-size: ${rem(28)};
    letter-spacing: ${rem(0.4)};
    line-height: ${rem(38)};
  }

  @media ${device.mobile} {
    display: ${props => (props.secondary ? `none` : `flex`)};
    background-image: ${`url(${headerMobileImage})`};

    img {
      content: url(${headerMobileImage});
    }
  }
`;

class Header extends Component {
  onClickMoreInfo = e => {
    e.preventDefault();
    this.props.onShowModal(e.target.dataset.target);
  };

  render() {
    const { secondary } = this.props;

    return (
      <HeaderWrapper secondary={secondary}>
        {secondary ? (
          <div className="logo-img">
            <img alt="Sky Recorrente" src={logoImage} />
            <p>Garanta a sua diversão todo mês, ganhe desconto e cancele quando quiser</p>
          </div>
        ) : null}
      </HeaderWrapper>
    );
  }
}

Header.propTypes = {
  onShowModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
});

export default connect(
  null,
  mapDispatchToProps,
)(Header);
